import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import { useMsal, useAccount } from '@azure/msal-react';
import { useAppDispatch } from '../../../app/hooks';
import { initializeAsset } from '../state';
import { PageContainer, PageCard } from '../../common/components/styled-ui-elements';
import { AssetCreateHeader, AssetCreateForm } from '../components/AssetForm';

/**
 * AssetCreate - Main page component for creating new assets
 * Provides a clean, organized interface with logical section groupings
 */
const AssetCreate: React.FC = () => {
  const dispatch = useAppDispatch();
  const { accounts } = useMsal();
  const account = useAccount(accounts[0] || {});

  useEffect(() => {
    const userName = account?.name || 'Unknown User';
    dispatch(initializeAsset(userName));
  }, [dispatch, account]);

  return (
    <PageContainer>
      <Box display="flex" justifyContent="center">
        <PageCard>
          <AssetCreateHeader />
          <AssetCreateForm />
        </PageCard>
      </Box>
    </PageContainer>
  );
};

export default AssetCreate;
